'undefined' == typeof WeakMap &&
    (function () {
        function e() {
            this.name = '__st' + ((1e9 * Math.random()) >>> 0) + t++ + '__'
        }
        var o = Object.defineProperty,
            t = Date.now() % 1e9
        ;(e.prototype = {
            set: function (e, t) {
                var n = e[this.name]
                return (
                    n && n[0] === e
                        ? (n[1] = t)
                        : o(e, this.name, { value: [e, t], writable: !0 }),
                    this
                )
            },
            get: function (e) {
                var t
                return (t = e[this.name]) && t[0] === e ? t[1] : void 0
            },
            delete: function (e) {
                var t = e[this.name]
                return !(!t || t[0] !== e) && ((t[0] = t[1] = void 0), !0)
            },
            has: function (e) {
                var t = e[this.name]
                return !!t && t[0] === e
            },
        }),
            (window.WeakMap = e)
    })(),
    (function (e) {
        if (!e.JsMutationObserver) {
            var i,
                s = new WeakMap()
            if (/Trident|Edge/.test(navigator.userAgent)) i = setTimeout
            else if (window.setImmediate) i = window.setImmediate
            else {
                var n = [],
                    o = String(Math.random())
                window.addEventListener('message', function (e) {
                    if (e.data === o) {
                        var t = n
                        ;(n = []),
                            t.forEach(function (e) {
                                e()
                            })
                    }
                }),
                    (i = function (e) {
                        n.push(e), window.postMessage(o, '*')
                    })
            }
            var l,
                f,
                a = !1,
                d = [],
                t = 0
            ;(r.prototype = {
                observe: function (e, t) {
                    var n
                    if (
                        ((n = e),
                        (e =
                            (window.ShadowDOMPolyfill &&
                                window.ShadowDOMPolyfill.wrapIfNeeded(n)) ||
                            n),
                        (!t.childList && !t.attributes && !t.characterData) ||
                            (t.attributeOldValue && !t.attributes) ||
                            (t.attributeFilter &&
                                t.attributeFilter.length &&
                                !t.attributes) ||
                            (t.characterDataOldValue && !t.characterData))
                    )
                        throw new SyntaxError()
                    var o,
                        r = s.get(e)
                    r || s.set(e, (r = []))
                    for (var i = 0; i < r.length; i++)
                        if (r[i].observer === this) {
                            ;(o = r[i]).removeListeners(), (o.options = t)
                            break
                        }
                    o ||
                        ((o = new h(this, e, t)),
                        r.push(o),
                        this.nodes_.push(e)),
                        o.addListeners()
                },
                disconnect: function () {
                    this.nodes_.forEach(function (e) {
                        for (var t = s.get(e), n = 0; n < t.length; n++) {
                            var o = t[n]
                            if (o.observer === this) {
                                o.removeListeners(), t.splice(n, 1)
                                break
                            }
                        }
                    }, this),
                        (this.records_ = [])
                },
                takeRecords: function () {
                    var e = this.records_
                    return (this.records_ = []), e
                },
            }),
                (h.prototype = {
                    enqueue: function (e) {
                        var t,
                            n = this.observer.records_,
                            o = n.length
                        if (0 < n.length) {
                            var r = v(n[o - 1], e)
                            if (r) return void (n[o - 1] = r)
                        } else
                            (t = this.observer),
                                d.push(t),
                                a || ((a = !0), i(u))
                        n[o] = e
                    },
                    addListeners: function () {
                        this.addListeners_(this.target)
                    },
                    addListeners_: function (e) {
                        var t = this.options
                        t.attributes &&
                            e.addEventListener('DOMAttrModified', this, !0),
                            t.characterData &&
                                e.addEventListener(
                                    'DOMCharacterDataModified',
                                    this,
                                    !0
                                ),
                            t.childList &&
                                e.addEventListener('DOMNodeInserted', this, !0),
                            (t.childList || t.subtree) &&
                                e.addEventListener('DOMNodeRemoved', this, !0)
                    },
                    removeListeners: function () {
                        this.removeListeners_(this.target)
                    },
                    removeListeners_: function (e) {
                        var t = this.options
                        t.attributes &&
                            e.removeEventListener('DOMAttrModified', this, !0),
                            t.characterData &&
                                e.removeEventListener(
                                    'DOMCharacterDataModified',
                                    this,
                                    !0
                                ),
                            t.childList &&
                                e.removeEventListener(
                                    'DOMNodeInserted',
                                    this,
                                    !0
                                ),
                            (t.childList || t.subtree) &&
                                e.removeEventListener(
                                    'DOMNodeRemoved',
                                    this,
                                    !0
                                )
                    },
                    addTransientObserver: function (e) {
                        if (e !== this.target) {
                            this.addListeners_(e),
                                this.transientObservedNodes.push(e)
                            var t = s.get(e)
                            t || s.set(e, (t = [])), t.push(this)
                        }
                    },
                    removeTransientObservers: function () {
                        var e = this.transientObservedNodes
                        ;(this.transientObservedNodes = []),
                            e.forEach(function (e) {
                                this.removeListeners_(e)
                                for (var t = s.get(e), n = 0; n < t.length; n++)
                                    if (t[n] === this) {
                                        t.splice(n, 1)
                                        break
                                    }
                            }, this)
                    },
                    handleEvent: function (e) {
                        switch ((e.stopImmediatePropagation(), e.type)) {
                            case 'DOMAttrModified':
                                var t = e.attrName,
                                    n = e.relatedNode.namespaceURI,
                                    o = e.target
                                ;((i = new p('attributes', o)).attributeName =
                                    t),
                                    (i.attributeNamespace = n)
                                var r =
                                    e.attrChange === MutationEvent.ADDITION
                                        ? null
                                        : e.prevValue
                                m(o, function (e) {
                                    if (
                                        e.attributes &&
                                        (!e.attributeFilter ||
                                            !e.attributeFilter.length ||
                                            -1 !==
                                                e.attributeFilter.indexOf(t) ||
                                            -1 !== e.attributeFilter.indexOf(n))
                                    )
                                        return e.attributeOldValue ? w(r) : i
                                })
                                break
                            case 'DOMCharacterDataModified':
                                var i = p('characterData', (o = e.target))
                                r = e.prevValue
                                m(o, function (e) {
                                    if (e.characterData)
                                        return e.characterDataOldValue
                                            ? w(r)
                                            : i
                                })
                                break
                            case 'DOMNodeRemoved':
                                this.addTransientObserver(e.target)
                            case 'DOMNodeInserted':
                                var a,
                                    d,
                                    s = e.target
                                d =
                                    'DOMNodeInserted' === e.type
                                        ? ((a = [s]), [])
                                        : ((a = []), [s])
                                var u = s.previousSibling,
                                    c = s.nextSibling
                                ;((i = p(
                                    'childList',
                                    e.target.parentNode
                                )).addedNodes = a),
                                    (i.removedNodes = d),
                                    (i.previousSibling = u),
                                    (i.nextSibling = c),
                                    m(e.relatedNode, function (e) {
                                        if (e.childList) return i
                                    })
                        }
                        l = f = void 0
                    },
                }),
                (e.JsMutationObserver = r),
                e.MutationObserver ||
                    ((e.MutationObserver = r)._isPolyfilled = !0)
        }
        function u() {
            a = !1
            var e = d
            ;(d = []),
                e.sort(function (e, t) {
                    return e.uid_ - t.uid_
                })
            var o = !1
            e.forEach(function (e) {
                var n,
                    t = e.takeRecords()
                ;(n = e).nodes_.forEach(function (e) {
                    var t = s.get(e)
                    t &&
                        t.forEach(function (e) {
                            e.observer === n && e.removeTransientObservers()
                        })
                }),
                    t.length && (e.callback_(t, e), (o = !0))
            }),
                o && u()
        }
        function m(e, t) {
            for (var n = e; n; n = n.parentNode) {
                var o = s.get(n)
                if (o)
                    for (var r = 0; r < o.length; r++) {
                        var i = o[r],
                            a = i.options
                        if (n === e || a.subtree) {
                            var d = t(a)
                            d && i.enqueue(d)
                        }
                    }
            }
        }
        function r(e) {
            ;(this.callback_ = e),
                (this.nodes_ = []),
                (this.records_ = []),
                (this.uid_ = ++t)
        }
        function c(e, t) {
            ;(this.type = e),
                (this.target = t),
                (this.addedNodes = []),
                (this.removedNodes = []),
                (this.previousSibling = null),
                (this.nextSibling = null),
                (this.attributeName = null),
                (this.attributeNamespace = null),
                (this.oldValue = null)
        }
        function p(e, t) {
            return (l = new c(e, t))
        }
        function w(e) {
            return (
                f ||
                (((n = new c((t = l).type, t.target)).addedNodes =
                    t.addedNodes.slice()),
                (n.removedNodes = t.removedNodes.slice()),
                (n.previousSibling = t.previousSibling),
                (n.nextSibling = t.nextSibling),
                (n.attributeName = t.attributeName),
                (n.attributeNamespace = t.attributeNamespace),
                (n.oldValue = t.oldValue),
                ((f = n).oldValue = e),
                f)
            )
            var t, n
        }
        function v(e, t) {
            return e === t ? e : f && ((n = e) === f || n === l) ? f : null
            var n
        }
        function h(e, t, n) {
            ;(this.observer = e),
                (this.target = t),
                (this.options = n),
                (this.transientObservedNodes = [])
        }
    })(self),
    (function () {
        'use strict'
        if (!window.performance) {
            var e = Date.now()
            window.performance = {
                now: function () {
                    return Date.now() - e
                },
            }
        }
        var t, n
        if (
            (window.requestAnimationFrame ||
                (window.requestAnimationFrame = (t =
                    window.webkitRequestAnimationFrame ||
                    window.mozRequestAnimationFrame)
                    ? function (e) {
                          return t(function () {
                              e(performance.now())
                          })
                      }
                    : function (e) {
                          return window.setTimeout(e, 1e3 / 60)
                      }),
            window.cancelAnimationFrame ||
                (window.cancelAnimationFrame =
                    window.webkitCancelAnimationFrame ||
                    window.mozCancelAnimationFrame ||
                    function (e) {
                        clearTimeout(e)
                    }),
            !((n = document.createEvent('Event')).initEvent('foo', !0, !0),
            n.preventDefault(),
            n.defaultPrevented))
        ) {
            var o = Event.prototype.preventDefault
            Event.prototype.preventDefault = function () {
                this.cancelable &&
                    (o.call(this),
                    Object.defineProperty(this, 'defaultPrevented', {
                        get: function () {
                            return !0
                        },
                        configurable: !0,
                    }))
            }
        }
        var r = /Trident/.test(navigator.userAgent)
        if (
            ((!window.CustomEvent ||
                (r && 'function' != typeof window.CustomEvent)) &&
                ((window.CustomEvent = function (e, t) {
                    t = t || {}
                    var n = document.createEvent('CustomEvent')
                    return (
                        n.initCustomEvent(
                            e,
                            Boolean(t.bubbles),
                            Boolean(t.cancelable),
                            t.detail
                        ),
                        n
                    )
                }),
                (window.CustomEvent.prototype = window.Event.prototype)),
            !window.Event || (r && 'function' != typeof window.Event))
        ) {
            var i = window.Event
            ;(window.Event = function (e, t) {
                t = t || {}
                var n = document.createEvent('Event')
                return (
                    n.initEvent(e, Boolean(t.bubbles), Boolean(t.cancelable)), n
                )
            }),
                (window.Event.prototype = i.prototype)
        }
    })(window.WebComponents),
    (window.CustomElements = window.CustomElements || { flags: {} }),
    (function (t) {
        var e = t.flags,
            n = []
        ;(t.addModule = function (e) {
            n.push(e)
        }),
            (t.initializeModules = function () {
                n.forEach(function (e) {
                    e(t)
                })
            }),
            (t.hasNative = Boolean(document.registerElement)),
            (t.isIE = /Trident/.test(navigator.userAgent)),
            (t.useNative =
                !e.register &&
                t.hasNative &&
                !window.ShadowDOMPolyfill &&
                (!window.HTMLImports || window.HTMLImports.useNative))
    })(window.CustomElements),
    window.CustomElements.addModule(function (e) {
        var s = window.HTMLImports
            ? window.HTMLImports.IMPORT_LINK_TYPE
            : 'none'
        function o(e, t) {
            !(function e(t, n, o) {
                var r = t.firstElementChild
                if (!r)
                    for (
                        r = t.firstChild;
                        r && r.nodeType !== Node.ELEMENT_NODE;

                    )
                        r = r.nextSibling
                for (; r; )
                    !0 !== n(r, o) && e(r, n, o), (r = r.nextElementSibling)
                return null
            })(e, function (e) {
                if (t(e)) return !0
                n(e, t)
            }),
                n(e, t)
        }
        function n(e, t) {
            for (var n = e.shadowRoot; n; ) o(n, t), (n = n.olderShadowRoot)
        }
        ;(e.forDocumentTree = function (e, t) {
            !(function e(t, n, o) {
                t = window.wrap(t)
                if (0 <= o.indexOf(t)) return
                o.push(t)
                var r = t.querySelectorAll('link[rel=' + s + ']')
                for (var i, a = 0, d = r.length; a < d && (i = r[a]); a++)
                    i.import && e(i.import, n, o)
                n(t)
            })(e, t, [])
        }),
            (e.forSubtree = o)
    }),
    window.CustomElements.addModule(function (n) {
        var a = n.flags,
            d = n.forSubtree,
            t = n.forDocumentTree
        function s(e, t) {
            return o(e, t) || r(e, t)
        }
        function o(e, t) {
            if (n.upgrade(e, t)) return !0
            t && m(e)
        }
        function r(e, t) {
            d(e, function (e) {
                if (o(e, t)) return !0
            })
        }
        var i = window.MutationObserver._isPolyfilled && a['throttle-attached']
        ;(n.hasPolyfillMutations = i), (n.hasThrottledAttached = i)
        var u = !1,
            c = []
        function l(e) {
            c.push(e), u || ((u = !0), setTimeout(f))
        }
        function f() {
            u = !1
            for (var e, t = c, n = 0, o = t.length; n < o && (e = t[n]); n++)
                e()
            c = []
        }
        function m(e) {
            i
                ? l(function () {
                      p(e)
                  })
                : p(e)
        }
        function p(e) {
            e.__upgraded__ &&
                !e.__attached &&
                ((e.__attached = !0),
                e.attachedCallback && e.attachedCallback())
        }
        function w(e) {
            i
                ? l(function () {
                      v(e)
                  })
                : v(e)
        }
        function v(e) {
            e.__upgraded__ &&
                e.__attached &&
                ((e.__attached = !1),
                e.detachedCallback && e.detachedCallback())
        }
        function h(e, t) {
            if (a.dom) {
                var n = t[0]
                if (
                    n &&
                    'childList' === n.type &&
                    n.addedNodes &&
                    n.addedNodes
                ) {
                    for (
                        var o = n.addedNodes[0];
                        o && o !== document && !o.host;

                    )
                        o = o.parentNode
                    var r =
                        (o &&
                            (o.URL ||
                                o._URL ||
                                (o.host && o.host.localName))) ||
                        ''
                    r = r.split('/?').shift().split('/').pop()
                }
                console.group('mutations (%d) [%s]', t.length, r || '')
            }
            var i = (function (e) {
                for (var t = e, n = window.wrap(document); t; ) {
                    if (t == n) return !0
                    t =
                        t.parentNode ||
                        (t.nodeType === Node.DOCUMENT_FRAGMENT_NODE && t.host)
                }
            })(e)
            t.forEach(function (e) {
                'childList' === e.type &&
                    (g(e.addedNodes, function (e) {
                        e.localName && s(e, i)
                    }),
                    g(e.removedNodes, function (e) {
                        var t
                        e.localName &&
                            (w((t = e)),
                            d(t, function (e) {
                                w(e)
                            }))
                    }))
            }),
                a.dom && console.groupEnd()
        }
        var g = Array.prototype.forEach.call.bind(Array.prototype.forEach)
        function b(e) {
            if (!e.__observer) {
                var t = new MutationObserver(h.bind(this, e))
                t.observe(e, { childList: !0, subtree: !0 }), (e.__observer = t)
            }
        }
        function E(e) {
            ;(e = window.wrap(e)),
                a.dom &&
                    console.group(
                        'upgradeDocument: ',
                        e.baseURI.split('/').pop()
                    ),
                s(e, e === window.wrap(document)),
                b(e),
                a.dom && console.groupEnd()
        }
        var _ = Element.prototype.createShadowRoot
        _ &&
            (Element.prototype.createShadowRoot = function () {
                var e = _.call(this)
                return window.CustomElements.watchShadow(this), e
            }),
            (n.watchShadow = function (e) {
                if (e.shadowRoot && !e.shadowRoot.__watched) {
                    a.dom &&
                        console.log('watching shadow-root for: ', e.localName)
                    for (var t = e.shadowRoot; t; )
                        b(t), (t = t.olderShadowRoot)
                }
            }),
            (n.upgradeDocumentTree = function (e) {
                t(e, E)
            }),
            (n.upgradeDocument = E),
            (n.upgradeSubtree = r),
            (n.upgradeAll = s),
            (n.attached = m),
            (n.takeRecords = function (e) {
                for (
                    e = (e = window.wrap(e)) || window.wrap(document);
                    e.parentNode;

                )
                    e = e.parentNode
                var t = e.__observer
                t && (h(e, t.takeRecords()), f())
            })
    }),
    window.CustomElements.addModule(function (r) {
        var i = r.flags
        function a(e, t, n) {
            var o
            return (
                i.upgrade && console.group('upgrade:', e.localName),
                t.is && e.setAttribute('is', t.is),
                d(e, t),
                (e.__upgraded__ = !0),
                (o = e).createdCallback && o.createdCallback(),
                n && r.attached(e),
                r.upgradeSubtree(e, n),
                i.upgrade && console.groupEnd(),
                e
            )
        }
        function d(e, t) {
            Object.__proto__ ||
                (function (e, t, n) {
                    var o = {},
                        r = t
                    for (; r !== n && r !== HTMLElement.prototype; ) {
                        for (
                            var i, a = Object.getOwnPropertyNames(r), d = 0;
                            (i = a[d]);
                            d++
                        )
                            o[i] ||
                                (Object.defineProperty(
                                    e,
                                    i,
                                    Object.getOwnPropertyDescriptor(r, i)
                                ),
                                (o[i] = 1))
                        r = Object.getPrototypeOf(r)
                    }
                })(e, t.prototype, t.native),
                (e.__proto__ = t.prototype)
        }
        ;(r.upgrade = function (e, t) {
            if (
                ('template' === e.localName &&
                    window.HTMLTemplateElement &&
                    HTMLTemplateElement.decorate &&
                    HTMLTemplateElement.decorate(e),
                !e.__upgraded__ && e.nodeType === Node.ELEMENT_NODE)
            ) {
                var n = e.getAttribute('is'),
                    o =
                        r.getRegisteredDefinition(e.localName) ||
                        r.getRegisteredDefinition(n)
                if (o && ((n && o.tag == e.localName) || (!n && !o.extends)))
                    return a(e, o, t)
            }
        }),
            (r.upgradeWithDefinition = a),
            (r.implementPrototype = d)
    }),
    window.CustomElements.addModule(function (d) {
        var e = d.isIE,
            s = d.upgradeDocumentTree,
            o = d.upgradeAll,
            u = d.upgradeWithDefinition,
            r = d.implementPrototype,
            t = d.useNative
        function c(e, t, n) {
            e = e.toLowerCase()
            var o = this.getAttribute(e)
            n.apply(this, arguments)
            var r = this.getAttribute(e)
            this.attributeChangedCallback &&
                r !== o &&
                this.attributeChangedCallback(e, o, r)
        }
        var l = [
            'annotation-xml',
            'color-profile',
            'font-face',
            'font-face-src',
            'font-face-uri',
            'font-face-format',
            'font-face-name',
            'missing-glyph',
        ]
        var f = {}
        function m(e) {
            if (e) return f[e.toLowerCase()]
        }
        function i(e, t) {
            e = e && e.toLowerCase()
            var n,
                o = m((t = t && t.toLowerCase()) || e)
            if (o) {
                if (e == o.tag && t == o.is) return new o.ctor()
                if (!t && !o.is) return new o.ctor()
            }
            return (
                t
                    ? (n = i(e)).setAttribute('is', t)
                    : ((n = p(e)), 0 <= e.indexOf('-') && r(n, HTMLElement)),
                n
            )
        }
        var n,
            a,
            p = document.createElement.bind(document),
            w = document.createElementNS.bind(document)
        function v(e, t) {
            var n = e[t]
            e[t] = function () {
                var e = n.apply(this, arguments)
                return o(e), e
            }
        }
        ;(n =
            Object.__proto__ || t
                ? function (e, t) {
                      return e instanceof t
                  }
                : function (e, t) {
                      if (e instanceof t) return !0
                      for (var n = e; n; ) {
                          if (n === t.prototype) return !0
                          n = n.__proto__
                      }
                      return !1
                  }),
            v(Node.prototype, 'cloneNode'),
            v(document, 'importNode'),
            e &&
                ((a = document.importNode),
                (document.importNode = function () {
                    var e = a.apply(document, arguments)
                    if (e.nodeType != e.DOCUMENT_FRAGMENT_NODE) return e
                    var t = document.createDocumentFragment()
                    return t.appendChild(e), t
                })),
            (document.registerElement = function (e, t) {
                var n,
                    o,
                    r,
                    i = t || {}
                if (!e)
                    throw new Error(
                        'document.registerElement: first argument `name` must not be empty'
                    )
                if (e.indexOf('-') < 0)
                    throw new Error(
                        "document.registerElement: first argument ('name') must contain a dash ('-'). Argument provided was '" +
                            String(e) +
                            "'."
                    )
                if (
                    (function (e) {
                        for (var t = 0; t < l.length; t++)
                            if (e === l[t]) return !0
                    })(e)
                )
                    throw new Error(
                        "Failed to execute 'registerElement' on 'Document': Registration failed for type '" +
                            String(e) +
                            "'. The type name is invalid."
                    )
                if (m(e))
                    throw new Error(
                        "DuplicateDefinitionError: a type with name '" +
                            String(e) +
                            "' is already registered"
                    )
                function a() {
                    return u(p((e = r).tag), e)
                    var e
                }
                return (
                    i.prototype ||
                        (i.prototype = Object.create(HTMLElement.prototype)),
                    (i.__name = e.toLowerCase()),
                    (i.lifecycle = i.lifecycle || {}),
                    (i.ancestry = (function e(t) {
                        var n = m(t)
                        if (n) return e(n.extends).concat([n])
                        return []
                    })(i.extends)),
                    (function (e) {
                        for (
                            var t, n = e.extends, o = 0;
                            (t = e.ancestry[o]);
                            o++
                        )
                            n = t.is && t.tag
                        ;(e.tag = n || e.__name), n && (e.is = e.__name)
                    })(i),
                    (function (e) {
                        if (!Object.__proto__) {
                            var t = HTMLElement.prototype
                            if (e.is) {
                                var n = document.createElement(e.tag)
                                t = Object.getPrototypeOf(n)
                            }
                            for (var o, r = e.prototype, i = !1; r; )
                                r == t && (i = !0),
                                    (o = Object.getPrototypeOf(r)) &&
                                        (r.__proto__ = o),
                                    (r = o)
                            i ||
                                console.warn(
                                    e.tag +
                                        ' prototype not found in prototype chain for ' +
                                        e.is
                                ),
                                (e.native = t)
                        }
                    })(i),
                    (function (e) {
                        if (e.setAttribute._polyfilled) return
                        var n = e.setAttribute
                        e.setAttribute = function (e, t) {
                            c.call(this, e, t, n)
                        }
                        var t = e.removeAttribute
                        ;(e.removeAttribute = function (e) {
                            c.call(this, e, null, t)
                        }),
                            (e.setAttribute._polyfilled = !0)
                    })(i.prototype),
                    (n = i.__name),
                    (o = i),
                    (f[n] = o),
                    (i.ctor =
                        ((r = i),
                        Object.assign(a, r.prototype.constructor),
                        a)),
                    (i.ctor.prototype = i.prototype),
                    (i.prototype.constructor = i.ctor),
                    d.ready && s(document),
                    i.ctor
                )
            }),
            (document.createElement = i),
            (document.createElementNS = function (e, t, n) {
                return 'http://www.w3.org/1999/xhtml' === e ? i(t, n) : w(e, t)
            }),
            (d.registry = f),
            (d.instanceof = n),
            (d.reservedTagList = l),
            (d.getRegisteredDefinition = m),
            (document.register = document.registerElement)
    }),
    (function (e) {
        var t = e.useNative,
            n = e.initializeModules
        e.isIE
        if (t) {
            function o() {}
            ;(e.watchShadow = o),
                (e.upgrade = o),
                (e.upgradeAll = o),
                (e.upgradeDocumentTree = o),
                (e.upgradeSubtree = o),
                (e.takeRecords = o),
                (e.instanceof = function (e, t) {
                    return e instanceof t
                })
        } else n()
        var r = e.upgradeDocumentTree,
            i = e.upgradeDocument
        function a() {
            r(window.wrap(document)),
                (window.CustomElements.ready = !0),
                (
                    window.requestAnimationFrame ||
                    function (e) {
                        setTimeout(e, 16)
                    }
                )(function () {
                    setTimeout(function () {
                        ;(window.CustomElements.readyTime = Date.now()),
                            window.HTMLImports &&
                                (window.CustomElements.elapsed =
                                    window.CustomElements.readyTime -
                                    window.HTMLImports.readyTime),
                            document.dispatchEvent(
                                new CustomEvent('WebComponentsReady', {
                                    bubbles: !0,
                                })
                            )
                    })
                })
        }
        if (
            (window.wrap ||
                (window.ShadowDOMPolyfill
                    ? ((window.wrap = window.ShadowDOMPolyfill.wrapIfNeeded),
                      (window.unwrap = window.ShadowDOMPolyfill.unwrapIfNeeded))
                    : (window.wrap = window.unwrap =
                          function (e) {
                              return e
                          })),
            window.HTMLImports &&
                (window.HTMLImports.__importsParsingHook = function (e) {
                    e.import && i(wrap(e.import))
                }),
            'complete' === document.readyState || e.flags.eager)
        )
            a()
        else if (
            'interactive' !== document.readyState ||
            window.attachEvent ||
            (window.HTMLImports && !window.HTMLImports.ready)
        ) {
            var d =
                window.HTMLImports && !window.HTMLImports.ready
                    ? 'HTMLImportsLoaded'
                    : 'DOMContentLoaded'
            window.addEventListener(d, a)
        } else a()
    })(window.CustomElements)
